const DASHBOARD_SELECTOR = '.rc-DashboardUploader';

const DASHBOARD_SOURCES_TAB_SELECTOR = 'uppy-DashboardTab';
const GOOGLE_DRIVE_PICKER_ID = 'GoogleDrivePicker';
const UPPY_SOURCE_ATTR = 'data-uppy-acquirer-id';
const GOOGLE_DRIVE_PICKER_BUTTON_SELECTOR = 'button[data-cy="GoogleDrivePicker"]';
const CONFIG = { childList: true, subtree: true };

/**
 * this is a hack that's needed because the dashboard contents are rendered by uppy and the state isn't exposed (ie so 
  this just waits until the dashboard is rendered. 
*/
export const useCreateGoogleDriveMutationObserver = (onGooglePickerSelected: () => void) => {
  const setupMutationObserver = () => {
    const targetNode = document.querySelector(DASHBOARD_SELECTOR);
    const callback = (mutationList: MutationRecord[]) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === 'childList' &&
          (mutation.addedNodes?.[0] as HTMLElement)?.classList?.contains(DASHBOARD_SOURCES_TAB_SELECTOR) &&
          (mutation.addedNodes?.[0] as HTMLElement)?.getAttribute(UPPY_SOURCE_ATTR) === GOOGLE_DRIVE_PICKER_ID
        ) {
          const button: HTMLButtonElement | null = document.querySelector(GOOGLE_DRIVE_PICKER_BUTTON_SELECTOR);

          button?.addEventListener('click', onGooglePickerSelected);
        }
      }
    };
    const observer = new MutationObserver(callback);

    if (targetNode) {
      observer.observe(targetNode, CONFIG);
    }
    return observer;
  };

  return setupMutationObserver;
};
